import { useContext, useEffect, useState } from "react";
import { useGetAllCustomVehiclesQuery } from "../../../../../Redux/service/Vehicles/CustomVehicles";
import { filtrationcontext } from "../../../../../context/Filtercontext";
import trans, { isRTL } from "../../../../../utils";
import { Tag } from "antd";
import { formatDateString } from "../../../../../JsHelpers/DateFormat";
import AntdTable from "../../../../antd/Table/Table";

export default function VehiclesTable({ limit, query, setLimit, setQuery }) {
  const { Sort, setSort: SetSortFilter } = useContext(filtrationcontext);
  const [currentPage, setCurrentPage] = useState(1);

  const [sort, setSort] = useState({
    by: "",
    order: "",
  });

  const { data, isLoading, isError } = useGetAllCustomVehiclesQuery(
    {
      page: currentPage,
      limit: limit,
      search: query,
      sortby: sort.by,
      sortorder: sort.order,
    },
    {
      skip: !currentPage || !limit,
    }
  );

  useEffect(() => {
    return () => {
      SetSortFilter({ type: "", value: null });
      setLimit(10);
      setQuery("");
      localStorage.setItem("page", 1);
    };
  }, [setLimit, SetSortFilter, setQuery]);

  const columns = [
    {
      title: trans("Vehicle"),
      dataIndex: "name",
      width: 150,
      fixed: !isRTL ? "left" : undefined,
      sorter: true,
      render: (value) => (
        <span className={"table-element-name ps-0"}>{value}</span>
      ),
    },
    {
      title: trans("IMEI"),
      dataIndex: "imei",
      width: 150,
      render: (value) => value || "- - - - -",
    },
    {
      title: trans("status"),
      dataIndex: "status",
      sorter: true,
      width: 150,
      render: (value) => (
        <Tag
          color={value === "unknown" || value === "offline" ? "red" : "green"}
        >
          {value === "unknown" || value === "offline" ? "offline" : "online"}
        </Tag>
      ),
    },
    {
      title: trans("Vehicle Expiry"),
      dataIndex: "vehicleExpires",
      width: 180,
      render: (value) => (value ? formatDateString(value) : "- - - - -"),
    },
    {
      title: trans("License Expiry"),
      dataIndex: "licenseExpire",
      width: 180,
      render: (value) => (value ? formatDateString(value) : "- - - - -"),
    },
  ];

  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter.order) {
      setSort({
        by: sorter.field,
        order: sorter.order === "ascend" ? "asc" : "desc",
      });
    } else {
      setSort({
        by: "",
        order: "",
      });
    }
  };

  return (
    <div className="mt-3 table-parent">
      <AntdTable
        columns={columns}
        dataSource={data?.vehicles || []}
        loading={isLoading}
        pageSize={limit}
        totalItems={data?.totalCount}
        currentPage={currentPage}
        onPageChange={(page) => setCurrentPage(page)}
        onLimitChange={(newLimit) => {
          setLimit(newLimit);
          setCurrentPage(1);
        }}
        onTableChange={handleTableChange}
        scrollY={300}
      />
    </div>
  );
}
